var r={Light:"300",Regular:"400",Medium:"600",Strong:"700",ExtraStrong:"800"};export{r as default};
